const NAME = 'dashboard';
const NAME_V2 = 'dashboardV2';
export default { NAME, NAME_V2 };

export const COLUMN_SIZES = {
  XXS: 'xxs',
  XS: 'xs',
  SM: 'sm',
  MD: 'md',
  LG: 'lg',
};

export const HEADER_CELL_TYPES = {
  FILTER: 'filter',
  NORMAL: 'normal',
};

export const EMPTY_MESSAGES = {
  subTitle: 'Properties will show up here',
  title: 'Make sure you have access into properties.',
};

export const FILTER_RESERVATION_TYPES = [
  { code: 'checkin', name: 'Check-in' },
  { code: 'checkout', name: 'Checkout' },
  { code: 'back_to_back', name: 'Back to Back' },
];

export const OLD_RESERVATION_FILTERS_PARSE_MAP = {
  backToBack: 'back_to_back',
  checkinOnly: 'checkin',
  checkoutOnly: 'checkout',
  hasReservation: 'any',
  noReservation: 'no_reservation',
};

export const MAP_DASHBOARD_CONTAINER_ID = 'google-map-dashboard-container';
